import { Indicator } from 'react-daisyui';
import { Link } from 'react-router-dom';
import { useUnreadNotifications } from '../../api/shared';
import { useCurrentUserAuth } from '../../hooks/useCurrentUserAuth';
import IconButton from '../IconButton';
import AppLoader from '../Loader';
import { NotificationDot } from './NotificationDot';

const NotificationIcon = () => {
  const { currentUser } = useCurrentUserAuth();

  const {
    data: hasUnreadNotifications,
    isLoading: isUnreadNotificationsLoading,
  } = useUnreadNotifications({
    userId: currentUser?._id,
  });

  return (
    <Link aria-label="Notifications" to="/profile/notifications">
      <Indicator>
        {hasUnreadNotifications && hasUnreadNotifications.items.length > 0 && (
          <NotificationDot className="right-[1.2rem] top-4 z-10" />
        )}
        {isUnreadNotificationsLoading ? (
          <div
            className="tooltip tooltip-bottom relative p-2"
            data-tip="Notifications"
          >
            <AppLoader.FlexLoader className="h-6 text-white" />
          </div>
        ) : (
          <IconButton
            label="Notifications"
            className="p-2 text-white"
            icon="bell"
            iconClassName="w-6 h-6"
            iconSize="6"
            tipPosition="bottom"
          />
        )}
      </Indicator>
    </Link>
  );
};

export default NotificationIcon;
